<template>
  <div class="dialogBox">
    <el-row style="margin-top: 20px;">
      <div>
        <el-col :span="10" class="leftTable">
          <div class="leftTitle">用户</div>
          <el-input
            v-model="searchValue"
            placeholder="请输入"
            class="input-with-select"
            size="mini"
            suffix-icon="el-icon-search"
            style="margin: 10px 0;"
            @input="handleSeelct"
          />
          <div style="height: 205px">
            <el-table
              :data="leftTableData"
              max-height="205"
              size="mini"
              :show-header="showHeader"
              style="width: 100%"
              :header-cell-style="tableHeaderColor"
              @selection-change="checkAll"
            >
              <el-table-column type="selection" width="50" />
              <el-table-column prop="name" label="姓名" width="80" />
              <el-table-column prop="phone" label="手机号" width="100" />
              <el-table-column prop="email" label="邮箱" />
            </el-table>
          </div>
        </el-col>
        <el-col :span="4" class="btnMove">
          <div>
            <div class="opSetting" @click="handelSelect">
              <el-button
                icon="el-icon-d-arrow-right"
                :disabled="nowSelectData.length?false:true"
                size="mini"
                type="primary"
              />
            </div>
            <div class="spacing" @click="handleRemoveSelect">
              <el-button
                icon="el-icon-d-arrow-left"
                :disabled="nowSelectRightData.length?false:true"
                size="mini"
                type="primary"
              />
            </div>
          </div>
        </el-col>
        <el-col :span="10" class="leftTable">
          <div style="background-color: #fff;height: 290px;">
            <el-table
              :data="rightTableData"
              max-height="290"
              size="mini"
              :header-cell-style="tableHeaderColor"
              @selection-change="checkRightAll"
            >
              <el-table-column type="selection" width="50" />
              <el-table-column prop="name" label="姓名" width="100" />
              <el-table-column prop="label" label="角色" width="160">
                <template slot-scope="scope">
                  <el-select
                    v-model="selectCode[scope.row.id]"
                    size="mini"
                    placeholder="请选择"
                    @change="selectInput(scope.row.id)"
                  >
                    <el-option
                      v-for="(item, i) in allUserList"
                      :key="i"
                      :label="item.name"
                      :value="item.id"
                    />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="role" label="关联单位" width="160">
                <template slot-scope="scope">
                  <el-select
                    v-model="selectDataList[scope.row.id]"
                    multiple
                    collapse-tags
                    size="mini"
                    placeholder="请选择"
                    @change="selectRole(scope.row.id)"
                  >
                    <el-option
                      v-for="item in unitAllLists"
                      :key="item.text"
                      :label="item.name"
                      :value="item.id"
                    />
                  </el-select>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-col>
      </div>
    </el-row>
    <div class="footer">
      <span slot="footer" class="dialog-footer">
        <el-button v-preventReClick type="primary" size="mini" @click="submit">确 定</el-button>
        <el-button size="mini" @click="cancel">取 消</el-button>
      </span>
    </div>
  </div>
</template>

<script>
import { getProjectId } from '@/utils/auth'
import { importUser } from '@/api/proUser'

export default {
  name: 'Consumer',
  props: {
    dataObj: {
      type: Array
    },
    dataUser: {
      type: Array

    },
    unitAllList: {
      type: Array
    }
  },
  data() {
    return {
      value: [1],
      roleValue: [],
      selectVal: '',
      proId: '',
      tableData: [],
      showHeader: true, // 是否显示表头
      searchValue: '', // 搜索值
      leftTableData: this.dataObj, // 左边表格数据
      leftTableData2: this.dataObj, // 左边表格数据,这个数据只在左移或者右移时改变
      rightTableData: [], // 右边表格数据
      nowSelectData: [], // 左边选中列表数据
      nowSelectRightData: [], // 右边选中列表数据
      selectDataList: [], // 下拉框选中的值
      selectCode: [],
      unitAllLists: this.unitAllList,
      code: '',
      allUserList: this.dataUser
    }
  },
  created() {
    this.proId = getProjectId()
  },
  methods: {
    handleSeelct(value) {
      console.log('修改值', value)
      this.leftTableData = value.length > 0 ? this.leftTableData2.filter(item => item.key.includes(this.searchValue)) : this.leftTableData2
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) { // 改表头颜色
      if (rowIndex === 0) {
        return 'background-color: #D6E4FF;color: #666;'
      }
    },
    checkAll(val) {
      this.nowSelectData = val
    },
    checkRightAll(val) {
      this.nowSelectRightData = val
    },
    // 移除
    handelSelect() {
      this.rightTableData = this.rightTableData.concat(this.nowSelectData)
      this.handleRemoveTabList(this.nowSelectData, this.leftTableData)
      this.handleRemoveTabList(this.nowSelectData, this.leftTableData2)
      this.nowSelectData = []
    },
    // 添加
    handleRemoveSelect() {
      this.leftTableData = this.handleConcatArr(this.leftTableData, this.nowSelectRightData)
      this.leftTableData2 = this.handleConcatArr(this.leftTableData2, this.nowSelectRightData)
      this.handleRemoveTabList(this.nowSelectRightData, this.rightTableData)
      this.nowSelectRightData = []
    },
    selectRole(id) {
      this.rightTableData.map(item => {
        if (item.id === id) {
          item.unit = this.selectDataList[id]
        }
      })
    },
    selectInput(id) {
      this.rightTableData.map(item => {
        if (item.id === id) {
          item.role = this.selectCode[id]
        }
      })
    },
    handleConcatArr(a, b) {
      let arr = []
      arr = arr.concat(a, b)
      return arr
    },
    handleRemoveTabList(isNeedArr, originalArr) {
      if (isNeedArr.length && originalArr.length) {
        for (let i = 0; i < isNeedArr.length; i++) {
          for (let k = 0; k < originalArr.length; k++) {
            if (isNeedArr[i]['id'] === originalArr[k]['id']) {
              originalArr.splice(k, 1)
              k--
            }
          }
        }
      }
    },
    validate() {
      if (!this.rightTableData || this.rightTableData.length === 0) {
        this.$message({
          type: 'warning',
          message: '请选择用户!'
        })
        return false
      }
      const booleanRoles = this.rightTableData.some(item => item.role === null || item.role === '' || item.role === undefined)
      const booleanUnit = this.rightTableData.some(item => item.unit === null || item.unit === '' || item.unit === undefined || item.unit.length <= 0)
      if (booleanRoles) {
        this.$message({
          type: 'warning',
          message: '请选择角色!'
        })
        return false
      }
      if (booleanUnit) {
        this.$message({
          type: 'warning',
          message: '请选择关联单位!'
        })
        return false
      }
      return true
    },

    submit() {
      if (this.validate()) {
        const o = this.rightTableData.map(item => {
          const obj = {}
          obj.role_id = item.role
          obj.unit_id_list = item.unit
          obj.id = item.userId
          return obj
        })
        const params = {
          project_id: this.proId,
          user_list: o
        }
        importUser(params).then(res => {
          if (res && res.code === 0) {
            this.$message({
              message: res.msg,
              type: 'success'
            })
            this.$emit('ok')
          } else {
            this.$message(res.msg)
          }
        }).catch(res => {
          console.log(res.msg)
        })
      }
    },
    cancel() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
.box {
  .tableBox {
    width: 100%;
    height: 300px;
    overflow-y: scroll;
  }
}

.dialogBox {
  .footer {
    text-align: center;
    margin-top: 30px;
  }

  .leftTable {
    background-color: #F0F5FF;
    padding: 5px;
    min-height: 300px;

    .leftTitle {
      text-align: center;
      font-size: 12px;
      color: #595959;
      font-weight: bold;
      background-color: #D6E4FF;
      padding: 10px 0;
    }
  }

  .btnMove {
    margin-top: 10%;
    text-align: center;

    .opSetting {
      margin: 10px 0;
    }
  }

  .transferBox {
    min-height: 300px;

    .el-transfer {
      .el-transfer-panel {
        width: 358px !important;
      }
    }
  }
}
</style>

